import React, { useState, useEffect, useReducer } from "react";
import moment from "moment";
import {
  Grid,
  Button,
  List,
  Box,
  TextField,
  SwipeableDrawer,
  FormControl,
  InputLabel,
  Typography,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogActions,
  CardContent,
  Card,
  CardActions,
  Tooltip,
  TablePagination,
  IconButton,
  CardMedia,
} from "@material-ui/core";
import PageTitle from "../../../components/PageTitle";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import useStyles from "../../../themes/style.js";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { MdRemoveRedEye, MdFileDownload } from "react-icons/md";
import { useLocation } from "react-router-dom";
import PaySlipImg from "../../../images/employee/paySlipCard.jpg";
import CustomPdfView from "../../../components/pdfViewer/CustomPdfView.js";
import CloseIcon from "@material-ui/icons/Close";
import NoDataFound from "../../../components/NoDataFound/index.js";

function ViewMyPaySlip() {
  const classes = useStyles();

  const token = localStorage.getItem("token");

  const [loader, setLoader] = useState(false);
  const mobileQuery = useMediaQuery("(max-width:600px)");
  const [payslipData, setPayslipdata] = useState([]);
  const location = useLocation();

  const [page, setPage] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [count, setCount] = useState(0);

  const [payslipView, setPayslipView] = useState({
    isView: false,
    url: "",
  });

  const handleViewPaySlipClose = () => {
    setPayslipView({
      isView: false,
      url: "",
    });
  };

  useEffect(() => {
    fetchPayslipDetails();
  }, []);

  const fetchPayslipDetails = async () => {
    try {
      setLoader(true);
      axios({
        method: "get",
        url: `${process.env.REACT_APP_SERVER}payslip/getUserPayslip?page=${currentPage}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).then(function (response) {
        setLoader(false);
        if (response.data.status === true) {
          const responseData = response.data.data;
          setPayslipdata(responseData);
          setCount(response.data.count);
        }
      });
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setLoader(true);
    setCurrentPage(newPage + 1);

    axios({
      method: "get",
      url: `${process.env.REACT_APP_SERVER}payslip/getUserPayslip?page=${currentPage}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
        setPayslipdata(response.data.data);
        setCount(response.data.count);
      }

      setLoader(false);
    });
  };

  const handlePayslipDownload = (item) => {
    window.location.href = `${process.env.REACT_APP_AWS_BUCKET_URL}${item}`;
  };

  const handlePayslipView = (item) => {
    setPayslipView({
      isView: true,
      url: `${process.env.REACT_APP_AWS_BUCKET_URL}${item}`,
    });
  };

  return (
    <div style={{ marginTop: "20px" }}>
      <Grid container direction="row" spacing={5} className={classes.heading}>
        <Grid item xs={9} sm={7} md={8} lg={6}>
          <PageTitle title="Pay Slip" />
        </Grid>
      </Grid>

      {payslipData.length === 0 && <NoDataFound height="80vh" message="No Data Found" />}

      <Grid container spacing={2}>
        {payslipData.map((item, index) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
            <Card
              style={{
                background: "#b3ccdb",
                boxShadow:
                  " rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px",
              }}
            >
              <CardMedia
                component="img"
                height="194"
                image={PaySlipImg}
                alt="Paella dish"
              />
              <CardContent>
                <p
                  style={{ fontSize: "20px", fontWeight: "500" }}
                >
                  Payslip for the Month of{" "}
                  {moment(item.date).format("MMMM YYYY")}
                </p>
              </CardContent>
              <CardActions disableSpacing>
                <IconButton
                  aria-label="add to favorites"
                  onClick={() => {
                    handlePayslipDownload(item.payslipFile);
                  }}
                >
                  <MdFileDownload />
                </IconButton>
                <IconButton
                  aria-label="share"
                  onClick={() => {
                    handlePayslipView(item.payslipFile);
                  }}
                >
                  <MdRemoveRedEye />
                </IconButton>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Grid container spacing={2} className={classes.pagination}>
        <TablePagination
          rowsPerPageOptions={[10]}
          component="div"
          count={count}
          rowsPerPage={10}
          page={page}
          onPageChange={handleChangePage}
        />
      </Grid>

     

      <Dialog
        aria-labelledby="dialog-title"
        onClose={handleViewPaySlipClose}
        open={payslipView.isView}
        fullWidth={true}
        maxWidth="md"
        PaperProps={{
          style: {
            width: "100%",
          },
        }}
      >
        <DialogContent>
          <Grid container direction="row" spacing={2}>
            <div
              className={`${classes.heading} ${classes.inputRoot} ${classes.pdfModalTitleText}`}
            >
              <div
                className={classes.inputRoot}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <Typography variant="subtitle2">PAYSLIP</Typography>
              </div>

              <div className={classes.pdfModalCloseBtn}>
                <CloseIcon
                  className={classes.closeBtn}
                  onClick={handleViewPaySlipClose}
                />
              </div>
            </div>
            {payslipView.url ? (
              <Grid item xs={12} style={{ marginTop: "40px" }}>
                <CustomPdfView resumeUrl={payslipView.url} />
              </Grid>
            ) : (
              <Grid item xs={12} style={{ marginTop: "40px", padding: "20px" }}>
                <Typography
                  variant="body"
                  style={{ color: "#686D76", textAlign: "center" }}
                  className={classes.flexCenter}
                >
                  No file found here...
                </Typography>
              </Grid>
            )}
            <div className={classes.sendWhatsapp + " " + classes.inputRoot}>
              <Button
                variant="contained"
                size="small"
                color="secondary"
                onClick={handleViewPaySlipClose}
              >
                Close
              </Button>
            </div>
          </Grid>
        </DialogContent>
      </Dialog>

      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}

export default ViewMyPaySlip;
